var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91129 5.22329C7.46835 5.94138 7.46835 6.94557 6.91129 7.66366L3.26613 12.3625C2.49108 13.3616 0.890392 12.8136 0.890392 11.5491L0.890392 1.33787C0.890392 0.0733895 2.49108 -0.474685 3.26613 0.524417L6.91129 5.22329Z",
    fill: "#B6B6CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrow);
export default __webpack_public_path__ + "static/media/table-arrow.100d3e715b1a071a01d841ff38e27cbc.svg";
export { ForwardRef as ReactComponent };